import { UPDATE_SIDEBAR_TAB } from "../../utils/constants";

export const setSidebarTab = (title) => ({
  type: UPDATE_SIDEBAR_TAB,
  payload: title,
});
